<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height= "70vh"  :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.ID }}</td>
                            <td><a target="blank" :href="'/phieu-xuat-kho/' + item.ExportReceiptID">{{item.ExportReceiptID}}</a></td>
                            <td>{{ item.Username }}</td>
                            <td>
                                <v-edit-dialog :return-value.sync="item.Status" large lazy persistent @save="saveItem(item)">
                                    <div>{{ item.Status | display_value(listStatus) }}</div>
                                    <template v-slot:input>
                                        <v-select v-model="item.Status" label="Trạng thái" :items="listStatus" item-value="value" item-text="name" single-line autofocus></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                            <td>{{ item.Note }}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td class="text-center">
                                <v-icon medium class="mr-2" @click="createExportReceipt(item.ID)" :disabled="item.ExportReceiptID>0">add</v-icon>
                                <v-icon medium class="mr-2" @click="linkExportReceipt(item.ID)" :disabled="item.ExportReceiptID>0">add_link</v-icon>
                                <v-icon medium class="mr-2" @click="openDetail(item.ID)">visibility</v-icon>
                                <v-icon medium @click="deleteItem(item.ID)" :disabled="item.Status == listStatusEnum.da_xu_ly">delete</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <v-dialog v-model="dialogTranCode" persistent max-width="700px">
            <v-card>
            <v-card-title>
                <span class="title">Danh sách mã vận đơn</span>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap pa-3>
                    <v-flex lg12 md12 sm12 pa-0 v-if="currentItem && currentItem.Packages">
                        <v-data-table fixed-header height= "70vh"  :headers="sub_headers" :items="currentItem.Packages" disable-pagination hide-default-footer :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr :id="'r-' + item.ID">
                                    <td>{{ item.OrderTransactionCode }}</td>
                                    <td>{{ item.Status | display_value(package_status) }}</td>
                                    <td class="text-end">{{ item.Weight | currency('', 1) }}</td>
                                    <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogTranCode = false">Đóng</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogExportReceipt" persistent max-width="500px">
            <v-card>
            <v-card-title>
                <span class="title">Danh sách phiếu xuất</span>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap pa-3>
                    <v-flex lg12 md12 sm12 pa-0>
                        <v-select :items="exportReceipts" v-model="selectedReceiptId" label="Mã phiếu xuất" item-value="ID" item-text="ID"></v-select>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogExportReceipt = false">Đóng</v-btn>
                <v-btn color="red darken-1" text @click="onLinkReceipt(selectedReceiptId)">OK</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            headers: [
                {
                    text: "ID",
                    value: "ID",      
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phiếu xuất",
                    value: "ExportReceiptID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.RECEIPT_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Số kiện",
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "Note",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            sub_headers: [
                {
                    text: "Mã vận đơn",
                    value: "OrderTransactionCode"
                },
                {
                    text: "Trạng thái",
                    value: "Status"
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    align: "end",
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end",
                },
            ],
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "exportReceipt_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            listStatus: configs.REQUEST_DELIVERY_STATUS,
            listStatusEnum: configs.REQUEST_DELIVERY_ENUM,
            dialogTranCode: false,
            dialogExportReceipt: false,
            package_status: configs.PACKAGE_STATUS,
            selectedReceiptId: 0
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: mapState({
        items: state => state.requestDelivery.all.data,
        total_rows: state => state.requestDelivery.all.total,
        loading: state => state.requestDelivery.loading,
        currentItem: state => state.requestDelivery.selected,
        exportReceipts: state => state.exportReceipt.all.data,
    }),
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("requestDelivery/getList", param);
        },
        saveItem(item) {
            this.$store.dispatch("requestDelivery/setDetail", {
                data: {...item},
                id: item.ID
            });
        },
        openDetail(id) {
            this.$store.dispatch("requestDelivery/getDetail", id).then(() => {
                this.dialogTranCode = true;
            })
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData() {
            this.$router.push({
                name: "RequestDeliveryDetail",
                params: {
                Pid: 'tao-moi',
                title: `Tạo mới yêu cầu`
                }
            });
        },
        createExportReceipt(id) {
            window.getApp.$emit('REQUEST_CONFIRM_ACTION', 'Bạn muốn tạo phiếu xuất?', 'export_receipt_create', id);
        },
        linkExportReceipt(id) {
            window.getApp.$emit('REQUEST_CONFIRM_ACTION', 'Bạn muốn gộp phiếu xuất?', 'export_receipt_link', id);
        },
        onConfirmAction(action, id) {
            if(action == 'export_receipt_create') {
                this.$store.dispatch("requestDelivery/getDetail", id).then(() => {
                    this.$store.dispatch("exportReceipt/setDetail", {
                            data: {
                                RequestID: this.currentItem.ID,
                                UID: this.currentItem.UID,
                                Username: this.currentItem.Username,
                                Status: configs.RECEIPT_STATUS_ENUM.chua_xuat,
                                FeeType: 1
                            },
                            id: 0
                        }).then((ret) => {
                            ret = ret.data ? ret.data : ret;
                            if(!_.isEmpty(ret) && ret.ID) {
                                this.$router.push({
                                    name: "ExportReceiptDetail",
                                    params: { Pid: ret.ID, title: `Chi tiết phiếu xuất (#${ret.ID})` }
                                });
                            }
                        });
                });
            }
            else if(action == 'export_receipt_link') {
                this.$store.dispatch("requestDelivery/getDetail", id).then(() => {
                    let param = {
                        filter: [
                            {
                                column: "UID",
                                value: this.currentItem.UID,
                                condition: "equal"
                            },
                            {
                                column: "Status",
                                value: 1,
                                condition: "equal"
                            }
                        ]
                    }
                    this.$store.dispatch("exportReceipt/getList", param).then((ret) => {
                        if(!_.isEmpty(ret) && ret.total > 0) {
                            this.dialogExportReceipt = true;
                        }
                    });
                });
            }
        },
        onLinkReceipt(exportReceiptId) {
            if(exportReceiptId > 0) {
                this.$store.dispatch("exportReceipt/setDetail", {
                    data: {
                        RequestID: this.currentItem.ID
                    },
                    id: exportReceiptId
                }).then((ret) => {
                    this.$router.push({
                        name: "ExportReceiptDetail",
                        params: { Pid: exportReceiptId, title: `Chi tiết phiếu xuất (#${exportReceiptId})` }
                    });
                });
                this.dialogExportReceipt = false;
            }            
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("requestDelivery/removeDetail", id);
        });
        this.$root.$on("CONFIRMED_ACTION", (item) => {
            this.onConfirmAction(item.action, item.id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("CONFIRMED_ACTION");
    }
};
</script>
